import TableRow from "@material-ui/core/TableRow";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class RendTableRow extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;

    return <TableRow>{children}</TableRow>;
  }
}

export default withStyles(styles)(RendTableRow);
